module.exports = __webpack_public_path__ + "wwjyxk.e85bf1b8.jpg";